import React, { Component } from 'react';
import radium, { Style } from 'radium';
import { FloatingLabelInput } from '@lyearn-team/frontend-components';
import $j from 'jquery';

class TextReviewCard extends Component {
  static styles = {};

  constructor(props) {
    super(props);
    this.state = {
      textBoxValue: ''
    };
  }

  componentDidMount() {
    this.responseTextChanged();
    $j(this.refs.textAreaWrapper)
      .find('textarea')
      .on('keydown', e => e.stopPropagation());
  }

  componentDidUpdate() {
    $j(this.refs.textAreaWrapper)
      .find('textarea')
      .on('keydown', e => e.stopPropagation());
  }

  clearInputValue = () => {
    this.setState({ textBoxValue: '' });
  };

  responseTextChanged = (e) => {
    const text = (e && e.target.value) || '';
    this.setState({ textBoxValue: text });
    this.props.getAllPeerQResponse(this.props.index, text, 'text');
  };

  render() {
    const styles = TextReviewCard.styles;
    const labelText = 'Write your feedback here..';
    return (
      <div className="textReviewCard" ref="textAreaWrapper">
        <div className="textAreaContainer" ref="textAreaContainer">
          <FloatingLabelInput
            ref="textInput"
            style={styles.textAreaMainContainer}
            inputStyle={styles.textAreaContainer}
            fullWidth={true}
            value={this.state.textBoxValue}
            textareaStyle={styles.textArea}
            hintText={labelText}
            hintStyle={styles.inputText}
            onChange={this.responseTextChanged}
            underlineShow={false}
            multiline={true}
            minRows={2}
            autoFocus={this.props.autoFocus}
          />
        </div>
        <Style rules={styles.classBased} scopeSelector=".textReviewCard" />
      </div>
    );
  }
}

TextReviewCard.styles = {
  textAreaMainContainer: {
    maxHeight: '110px'
  },
  textAreaContainer: {
    border: '1px solid #DBE2E8',
    boxSizing: 'border-box',
    height: '110px',
    overflow: 'auto',
    maxHeight: '110px'
  },
  textArea: {
    margin: '0px',
    padding: '16px 20px',
    // color: 'rgba(0,0,0,0.26)',
    color: 'rgba(0,0,0,0.8)',
    letterSpacing: '0.11px',
    height: '100px'
  },
  inputText: {
    top: '16px',
    left: '20px',
    right: '0px',
    border: '0px',
    bottom: '16px'
  }
};

export default radium(TextReviewCard);
